import React, { memo, useMemo } from 'react';
import moment from 'moment';
import { Dashboard } from '../../../../../types/files';
import DashboardStatusMenu from '../../../../molecules/dashboard-menus/DashboardStatusMenu';

const StatusCell: React.FC<{ dashboard: Dashboard; readOnly?: boolean }> = ({ dashboard, readOnly }) => {
    const statusHistory = useMemo(() => {
        if (!dashboard.history || dashboard.history.length === 0) {
            // No history = pristine/legacy dashboard, show current status only
            return dashboard.status ? [{ status: dashboard.status, timestamp: dashboard.createdAt }] : [];
        }

        // History entries store the value the field changed TO, sorted newest first
        return dashboard.history
            .filter(e => e.status != null)
            .map(e => ({ status: e.status!, timestamp: e.changedAt }))
            .sort((a, b) => moment(b.timestamp).diff(moment(a.timestamp)));
    }, [dashboard.history, dashboard.status, dashboard.createdAt]);

    return (<>
        <DashboardStatusMenu dashboard={dashboard} readOnly={readOnly} statusHistory={statusHistory} />
    </>);
}

export default memo(StatusCell);
